import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Paragraph, Tag } from '@digdir/designsystemet-react';
import { ScheduledSurveyPresenter } from '../../../domain/custom-survey/scheduled-survey-presenter';
import type { PlannedSurveyListItem } from '../../../domain/surveys/survey-list';
import { ModuleIcon } from './ModuleIcon';
import classes from '../SurveysPage.module.css';

type PlannedSurveyRowProps = {
  item: PlannedSurveyListItem;
  onCancel: (item: PlannedSurveyListItem) => void;
};

export const PlannedSurveyRow = ({ item, onCancel }: PlannedSurveyRowProps) => {
  const { t } = useTranslation();

  return (
    <li className={classes.row}>
      <div className={classes.surveyCell}>
        <ModuleIcon module={item.module} />
        <div className={classes.titleBlock}>
          <span className={classes.moduleName}>{t(`surveys.page.modules.${item.module}`)}</span>
          <span className={classes.title}>{item.title}</span>
          <span className={classes.meta}>
            {t('surveys.page.planned.sendsAt', {
              date: ScheduledSurveyPresenter.formatScheduledDate(item.scheduledTime.toISOString()),
            })}
          </span>
        </div>
      </div>
      <div className={classes.responsesCell}>
        <Paragraph data-size="sm">{item.frequencyLabel}</Paragraph>
      </div>
      <div className={classes.resultCell}>
        <Tag data-size="sm" data-color="info">
          {t('surveys.page.planned.tag')}
        </Tag>
      </div>
      <div className={classes.actions}>
        <Button asChild variant="secondary" data-size="sm">
          <Link to={item.editRoute} aria-label={t('surveys.page.actions.editLabel', { title: item.title })}>
            {t('surveys.page.actions.edit')}
          </Link>
        </Button>
        <Button
          variant="tertiary"
          data-size="sm"
          onClick={() => onCancel(item)}
          aria-label={t('surveys.page.actions.cancelLabel', { title: item.title })}
        >
          {t('surveys.page.actions.cancel')}
        </Button>
      </div>
    </li>
  );
};
